var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._v(" "+_vm._s(_vm.config)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.pdfUrl)+" "),_c('iframe',{attrs:{"src":_vm.pdfUrl,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }